import _ from 'lodash';

import { PATH } from '../../constants/path';

export const convertPartnerNameForUrl = name => _.kebabCase(_.deburr(name));

/**
 * Retourne l'url vers la fiche d'un partenaire
 * @param {JSON} contient le nom du partenaire à inclure dans l'url et son id
 */

export function getMerchantCardUrl({ id, name }) {
    return name && id ? `${PATH.MERCHANTPAGE_PATH}${convertPartnerNameForUrl(name)}-${id}` : '';
}

/**
 * Retourne l'url vers l'instertitiel cashback
 * TODO: à bouger dans la future feature interstitiel. Créer un utils avec toutes les fonctions pour créer des urls d'interstitiels
 */
export function getInstertitielCashbackUrl({ id }) {
    return id ? `${PATH.INTERSTITIEL_CASHBACK_PATH}${id}/0` : '';
}

export const displayableCashback = (percent, fixed) => {
    const cashback = [];
    percent && cashback.push(`${percent}%`);
    fixed && cashback.push(`${fixed}€`);
    return `${cashback.join(' + ').replace(/[.]/g, ',')}`;
};

export const displayableCashbackComplete = (partner = null, partnerI18n = null) => {
    if (_.isEmpty(partner) || _.isEmpty(partnerI18n)) {
        return '';
    }

    if (hasCashback(partner)) {
        let content = '';
        if (partner && partner.isMultiDiscount) {
            content += `${partnerI18n.jusqua} `;
        }
        content += `${displayableCashback(
            partner.mostDisplayableDiscountOnline.percent,
            partner.mostDisplayableDiscountOnline.fixed
        )} ${renderPluralConditional(
            partnerI18n.rembourse,
            () =>
                partner &&
                (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                    partner.mostDisplayableDiscountOnline.percent > 1)
        )} `;
        if (partner.isMultiDiscount) {
            content += `${partnerI18n.aulieude} `;
            content += `${displayableCashback(
                partner.mostDisplayableDiscountOnline.initialPercent,
                partner.mostDisplayableDiscountOnline.initialFixed
            )}`;
        }
        return content;
    } else {
        return partnerI18n.pasdecashbackencemoment;
    }
};

export const renderPluralConditional = (str, condition) => {
    return str && condition && condition() ? str + 's' : str;
};

export const hasCashback = partner =>
    partner &&
    partner.mostDisplayableDiscountOnline &&
    (partner.mostDisplayableDiscountOnline.fixed > 0 ||
        partner.mostDisplayableDiscountOnline.percent > 0);

export const hasCoupon = partner => partner && partner.couponCount > 0;

export const isMultiDiscount = partner => partner && partner.isMultiDiscount === true;



// WEBPACK FOOTER //
// ./src/services/partner/utils.js